import { render, staticRenderFns } from "./SyllablesTestLine.vue?vue&type=template&id=95e19452&scoped=true"
import script from "./SyllablesTestLine.vue?vue&type=script&lang=ts"
export * from "./SyllablesTestLine.vue?vue&type=script&lang=ts"
import style0 from "./SyllablesTestLine.vue?vue&type=style&index=0&id=95e19452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e19452",
  null
  
)

export default component.exports